import Vue from "vue";
import Vuetify from "vuetify";

// import plugin
// don't forget to import CSS styles
// Vuetify's CSS styles

import "vuetify/dist/vuetify.min.css";

const vuetify = new Vuetify({
  icons: {
    iconfont: "mdiSvg"
  },
  theme: {
    themes: {
      light: {
        primary: "#2196F3",
        secondary: "#424242",
        accent: "#82B1FF",
        error: "#FF5252",
        info: "#ee44aa",
        success: "#4CAF50",
        warning: "#FFC107"
      }
    }
  }
});

Vue.use(Vuetify);

// use this package's plugin

export default vuetify;
